exports = module.exports = require("../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".Pfd-IvGRjtMQLiG8ATORo{display:none}._1vjgJBU6asEidnh7Z9Gko9{width:100%;height:calc(100% - 80px)}._1zA5fXc39QLnP4XU_bgU8K{height:calc(100% - 70px)}._1fEzf3V7tGXXcDKQ3neR4r{display:block;top:0;width:100%;height:100%;-webkit-box-sizing:border-box;box-sizing:border-box}._1fEzf3V7tGXXcDKQ3neR4r iframe{max-height:100%}._3C8lHSTTf5JcDtS9Vfmtft{display:none}", ""]);
// Exports
exports.locals = {
	"divContainer": "Pfd-IvGRjtMQLiG8ATORo",
	"extensionContainer": "_1vjgJBU6asEidnh7Z9Gko9",
	"extensionContainerCalendar": "_1zA5fXc39QLnP4XU_bgU8K",
	"extensionHost": "_1fEzf3V7tGXXcDKQ3neR4r",
	"hide": "_3C8lHSTTf5JcDtS9Vfmtft"
};